import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import db from '../db';

export default function Header() {
  const menuRef = React.createRef();
  let location = useLocation();


  const toggleMenu = (e) => {
    let menu = menuRef.current;
    if (menu.classList.contains("open")) {
      menu.classList.remove("open")
    } else {
      menu.classList.add("open");
    }
  }


  useEffect(() => {
    window.onresize = (e) => {
      let menu = menuRef.current;
      if (window.innerWidth > 767.20) {
        menu.classList.remove("open")
      }
    }
  }, [menuRef])




  return (
    <header className={`header${['/', '/ana-səhifə', '/ana-səhifə/'].includes(location.pathname) ? ' dark' : ''}`}>
      <div className='head-line'>
        <ul className="top-links">
          <li>
            <a href={db.contacts.map} target='_blank' rel="noreferrer"><img src="/Images/Icons/Contact/map1.png" alt={"contacts map icon"}/></a>
          </li>
          <li>
            <a href={db.contacts.instagram} target='_blank' rel="noreferrer"><img src="/Images/Icons/Contact/ig1.png"  alt={"contacts instagram icon"}/></a>
          </li>
          <li>
            <a href={db.contacts.facebook} target='_blank' rel="noreferrer"><img src="/Images/Icons/Contact/fb1.png"  alt={"contacts facebook icon"}/></a>
          </li>
          <li>
            <a href={db.contacts.whatsappLink} target='_blank' rel="noreferrer"><img src="/Images/Icons/Contact/wa1.png"  alt={"contacts whatsapp icon"}/></a>
          </li>
        </ul>
      </div>
      <div className="menu-line">
        <div className='logo'>
          <Link to="/"><img src='/Images/Logos/logo_negative.png'  alt={"kodart logo negative"}/></Link>
        </div>
        <ul className='menu' ref={menuRef}>
          <li>
            <Link to='/'>Ana səhifə</Link>
          </li>
          <li>
            <Link to='/təlimlər'>Təlimlər</Link>
          </li>
          {/* <li>
          <Link to='/xidmətlər'>Xidmətlər</Link>
        </li> */}
          <li>
            <Link to='/əlaqə'>Əlaqə</Link>
          </li>
          <li>
            <a href={db.contacts.whatsappLink} target='_blank' rel="noreferrer" className="header-wa-btn">
              <img src="/Images/Icons/Contact/wa1.png" alt={"whatsapp icon"}/>
              <span className="button-text">Müraciət</span>
            </a>
          </li>
        </ul>
        
        <div className="mobile-menu" onClick={toggleMenu}>
          <img src="/Images/Icons/mobile-menu.svg"  alt={"hamburger menu icon"}/>
        </div>
      </div>

    </header>
  )
}
